import * as React from "react";
import { cn } from "@app/ui/lib/Utils";
import type {
  TaskSummaryEditorProps,
  TaskSummaryEditorHandle,
} from "./TaskSummaryEditor";

export type { TaskSummaryEditorProps, TaskSummaryEditorHandle };

const LazyEditor = React.lazy(() =>
  import("./TaskSummaryEditor").then((m) => ({ default: m.TaskSummaryEditor })),
);

// 모듈 스코프에서 유휴 시간에 미리 받아두는 프리페치는 일부러 넣지 않았다 — 이
// 컴포넌트는 @app/ui 배럴(index.ts)을 통해 재export되는데, 배럴은 로그인 화면처럼
// "@app/ui" 에서 단 하나(Button 등)만 가져와도 전체가 평가된다(named re-export 는
// 트리셰이킹으로 지워지지 않는 top-level 부작용으로 취급됨). 즉 모듈 스코프 프리페치는
// 로그인 화면에서도 tiptap(500KB대)을 받아버리는 회귀가 된다 — 실측으로 확인됨.
// 그래서 이 래퍼는 실제로 렌더될 때(=대시보드 컴포저/task 상세)만 청크를 요청한다.

/** {@link TaskSummaryEditorProps} 와 동일한 API 를 유지하는 lazy 래퍼. 실제 tiptap
 * 구현은 별도 청크(./task-summary-editor)로 분리돼 있다. 첫 마운트 타이밍 경쟁을
 * 막기 위해 fallback 은 최종 에디터와 같은 className 을 받는 빈 컨테이너로 둔다. */
export function TaskSummaryEditor(props: TaskSummaryEditorProps) {
  return (
    <React.Suspense fallback={<div className={cn(props.className)} />}>
      <LazyEditor {...props} />
    </React.Suspense>
  );
}
